<template>
    <div class="downloadCard"@click="clickLink">
        <img src="@/assets/downloadCard-icon.png">
        <p :title="cardData.Title">{{cardData.Title}}</p>
        <!-- <a :href="cardData.DownloadUrl"><img src="@/assets/download_blue.png"></a> -->
        <img src="@/assets/download_blue.png">
    </div>
</template>
<script>
export default {
  name: "downloadCard",
  props: {
    cardData: Object
  },
  methods: {
    clickLink() {
      this.$router.push({
        name: 'downloadDetail', 
        params: {type: this.$route.params.type},
        query: {id: this.cardData.Id}
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.downloadCard {
  padding: 20px;
  border-width: 1px;
  border-style: solid;
  border-color: #d7d7d7;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  color: #333333;
  cursor: pointer;
  transition: .2s;
  &:hover {
    border-width: 1px;
    border-style: solid;
    border-color: #d7d7d7;
    border-radius: 3px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  img {
    height: 48px;
    margin-right: 10px;
  }
  p {
    @include hideTextOverflow;
  }
}
</style>

